import styled from "styled-components";

const Text = styled.p`
  font-size: 18px;
  margin: 0;
  font-weight: 200;

  @media (max-width: 1199.98px) {
    font-size: 16px;
  }
  @media (max-width: 767px) {
    font-size: 12px;
  }
`;
export default Text;
